import React, { Component } from "react";
import { connect } from "react-redux";

import { enTokenCMD } from "../lib/classTalk/CodeEnum";
import { ctActionType } from "../lib/ConstCommand";

import GroupChatList from "../components/pblGroupChat/GroupChatList";

import { initGroupChat, groupChatPopupInitialize, openPersonalChat } from "../modules/groupChat";

class PBLGroupChattingPopupContainer extends Component {
    
    componentDidMount() {
        console.log("PBLGroupChattingPopupContainer componentDidMount");

        const { routeProps } = this.props;
        if (routeProps.match && routeProps.match.params) {
            const liveSeq = routeProps.match.params.liveSeq;
            console.log("PBLGroupChattingPopupContainer - have to liveSeq: ", liveSeq);

            if (Number(liveSeq) > 0) {
                console.log("activeLive - ", this.props.activeLive);
                this.props.groupChatPopupInitialize();
                //this.props.initGroupChat({ liveSeq });
            }
        }
    }

    handleSelectedGroupChatFunc = ({ selectedFunc, userSeq, data }) => {
        switch(selectedFunc) {
            case "OPEN_PER_CHAT":
                this.props.openPersonalChat({ memberSeqList: [{userSeq}] });
                break;

            default:
                break;
        }
    }

    render() {
        return (
            <>
                <GroupChatList
                    list_groupChat={this.props.list_groupChat}
                    handleSelectedGroupChatFunc={this.handleSelectedGroupChatFunc}
                />
            </>
        );
    }   
}
export default connect(
    ({ live, groupChat }) => ({
        list_groupChat: groupChat.list_groupChat,

        activeLive    : live.list_live.find(info => info.selectStatus === "Y") !== undefined && 
                        live.list_live.find(info => info.selectStatus === "Y") !== null ?
                        live.list_live.find(info => info.selectStatus === "Y") :
                        {
                            liveSeq: -1,
                            liveName: "",
                            list_member: [],
                            mixedClassStatus: "N"
                        },
    }),
    {
        initGroupChat,
        groupChatPopupInitialize,
        openPersonalChat
    }
)(PBLGroupChattingPopupContainer);